var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Auth',[_c('PasswordCreationForm',{attrs:{"saving":_vm.saving,"error-text":_vm.errorText},on:{"create":_vm.createNewPassword}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }